import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      title: 'Total RFQs',
      value: stats?.total || 0,
      icon: 'FileText',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'Pending Review',
      value: stats?.pending || 0,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      change: '+5%',
      changeType: 'neutral'
    },
    {
      title: 'In Progress',
      value: stats?.inProgress || 0,
      icon: 'Activity',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: 'Quotes Sent',
      value: stats?.quoted || 0,
      icon: 'Send',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+15%',
      changeType: 'positive'
    },
    {
      title: 'Conversion Rate',
      value: `${stats?.conversionRate || 0}%`,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+3%',
      changeType: 'positive'
    },
    {
      title: 'Avg Response Time',
      value: `${stats?.avgResponseTime || 0}h`,
      icon: 'Timer',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '-2h',
      changeType: 'positive'
    }
  ];

  const getChangeColor = (type) => {
    switch (type) {
      case 'positive':
        return 'text-success';
      case 'negative':
        return 'text-error';
      default:
        return 'text-muted-foreground';
    }
  };

  const formatValue = (value) => {
    if (typeof value === 'number' && value >= 1000) {
      return new Intl.NumberFormat('en-UG', {
        notation: 'compact',
        maximumFractionDigits: 1
      })?.format(value);
    }
    return value;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-4 hover:shadow-moderate transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} className={stat?.color} />
            </div>
            <div className={`text-xs font-medium ${getChangeColor(stat?.changeType)}`}>
              {stat?.change}
            </div>
          </div>
          
          <div>
            <p className="text-2xl font-bold text-foreground mb-1">
              {formatValue(stat?.value)}
            </p>
            <p className="text-sm text-muted-foreground">{stat?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;